<template>
  <a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
      <div class="row no-gutters">
        <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
          <div class="card-body">
            <div class="row">
              <div class="col-md-7 align-self-center">
                <div v-if="reportDescription != ''" class="card">
                  <div class="card-body">
                    <div class="card-text">
                      {{ reportDescription }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <base-input label="Company Selection" class="col-md-6">
                <a-select
                  style="width: 100%"
                  placeholder="Select a Company"
                  optionFilterProp="children"
                  v-model="selectedCompanyId"
                  @change="updateSiteList"
                  showSearch
                >
                  <a-select-option v-for="company in validCompanies" :key="company.id" :value="company.id">
                    {{ company.name }}
                  </a-select-option>
                </a-select>
              </base-input>

              <base-input label="Site Selection" class="col-md-6">
                <a-select
                  style="width: 100%"
                  placeholder="Please select"
                  optionFilterProp="children"
                  v-model="selectedSiteId"
                  @change="updateTerminalList"
                  :disabled="site_type != 'ho'"
                  showSearch
                >
                  <a-select-option v-for="site in validSites" :key="site.id" :value="site.id">
                    {{ site.name }}
                  </a-select-option>
                </a-select>
              </base-input>

              <base-input label="Date Range" class="col-md-6">
                <br />
                <a-range-picker
                  @change="onDateFilter2"
                  :format="dateFormat"
                  :allowClear="false"
                  input-classes="form-control"
                  style="width: 100%"
                />
              </base-input>

              <base-input label="Terminal" class="col-md-6">
                <a-select
                  style="width: 100%"
                  placeholder="Please select"
                  optionFilterProp="children"
                  v-model="selectedTerminalId"
                  showSearch
                >
                  <a-select-option v-for="terminal in validTerminals" :key="terminal.id" :value="terminal.id">
                    {{ terminal.name }} ({{ terminal.code }})
                  </a-select-option>
                </a-select>
              </base-input>
            </div>
            <div class="row">
              <div class="col-md-12">
                <br />
                <download-excel
                  worksheet="E-Sales Reports"
                  name="bir_e_sales_reports.xlsx"
                  type="xlsx"
                  :fetch="excelData"
                  :fields="json_fields"
                >
                  <button class="btn btn-sm btn-success float-right ml-2" style="border-radius: 24px; border: 0px; width: 20%;">
                    Generate Report in Excel
                  </button>
                </download-excel>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </a-spin>
</template>

<script>
import HTTPRequest from "../../controllers/httpRequest.js";
import secureStorage from "../../controllers/secureStorage";
import moment from "moment";
import { getReportDescription } from "../../utilities";
import { mapState } from "vuex";

export default {
  data() {
    return {
      spinning: false,
      selectedCompanyId: null,
      selectedSiteId: [],
      site_type: "ho",
      selectedTerminalId: [],
      dateFormat: "YYYY-MM-DD",
      searchDateFrom: null,
      searchDateTo: null,
      validCompanies: null,
      validSites: null,
      validTerminals: null,
      jsonData: [],
      json_fields: {
        TIN: "tin",
        "Branch Code": "branchCode",
        Month: "month",
        Year: "year",
        MIN: "min",
        "Last OR": "lastOr",
        "Vatable Sales": "vatableSales",
        "Zero-Rated Sales": "zeroRatedSales",
        "Vat Exempt Sales": "vatExemptSales",
        "Subject Sales to Other Percentage Taxes": "subjectSalesToOtherPercentageTaxes",
      },
      reportDescription: "",
    };
  },
  mounted: async function () {
    // const userId = secureStorage.getItem("userId");
    this.validCompanies = await HTTPRequest.getRequest(`${this.endPoint}companies/get_valid_companies`, null);
    this.reportDescription = await getReportDescription(this.currentProfile);
  },
  computed: {
    ...mapState(["currentProfile", "currentApiURL", "endPoint", "parameters"]),
  },
  methods: {
    moment,
    async updateSiteList() {
      const site_data = await HTTPRequest.getRequest(`${this.endPoint}sites/get_valid_sites?company_id=${this.selectedCompanyId}`, null);
      this.validSites = site_data;
      this.selectedSiteId = null;
      this.validTerminals = null; // reset terminals when company or site changes
    },
    async updateTerminalList() {
      const terminal_data = await HTTPRequest.getRequest(`${this.endPoint}terminals/get_valid_terminals?site_id=${this.selectedSiteId}`, null);
      this.validTerminals = terminal_data;
    },
    onDateFilter2(date, dateString) {
      this.searchDateFrom = dateString[0];
      this.searchDateTo = dateString[1];
    },
    async excelData() {
      this.spinning = true;

      if (!this.searchDateFrom || !this.searchDateTo || !this.selectedCompanyId) {
        this.$notification.error({
          message: "Export Error",
          description: "Please make sure to select a company and date range.",
        });
        this.spinning = false;
        return;
      }

      this.jsonData = [];
      const url = `${this.endPoint}z_readings/bir_e_sales_report?from=${this.searchDateFrom}&to=${this.searchDateTo}&company_id=${this.selectedCompanyId}${
        this.selectedSiteId ? `&site_id=${this.selectedSiteId}` : ""
      }${this.selectedTerminalId ? `&terminal_id=${this.selectedTerminalId}` : ""}`;
      const queryResult = await HTTPRequest.getRequest(url, null);
      // console.log(queryResult);

      if (!queryResult || !Array.isArray(queryResult) || queryResult.length === 0) {
        this.$notification.warning({
          message: "Export Error",
          description: "No data found for the given filters.",
        });
        this.spinning = false;
        return [];
      }

      queryResult.forEach((report) => {
        this.jsonData.push({
          tin: report.tin || "",
          branchCode: "=\"" + report.branch_code + "\"" || "",
          month: report.month || "",
          year: report.year || "",
          min: report.min || "",
          lastOr: report.last_or || "",
          vatableSales: report.vatable_sales || 0,
          zeroRatedSales: report.zero_rated_sales || 0,
          vatExemptSales: report.vat_exempt_sales || 0,
          subjectSalesToOtherPercentageTaxes: report.subject_to_other_percentage_taxes || 0,
        });
      });

      this.spinning = false;
      console.log(this.jsonData)
      return this.jsonData;
    },
  },
};
</script>
